import { Component, OnInit } from "@angular/core";
import { NgbModal, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import { LanguageService } from "../../shared/services/language/language.service";
import { first } from "rxjs/operators";
import { AlertService } from "src/app/shared";
import Swal from "sweetalert2";


@Component({
  selector: "app-language-list",
  templateUrl: "./language-list.component.html",
  styleUrls: ["./language-list.component.scss"]
})
export class LanguageListComponent implements OnInit {
  public searchKey: any;
  public largeModal: any;
  successMessage: string;
  errorMessage: string;

  languages: any = [];
  currentLanguage = {
    code: "",
    name: "",
    _id: ""
  };

  sender = "language-list";

  error: any;
  languageCode: any;
  languageName: any;
  languageres: any;



  constructor(
    private modalService: NgbModal,
    private languageServiceApi: LanguageService,
    private alertService: AlertService
  ) { }

  ngOnInit() {
    this.getLanguages();
  }

  open(content, lang) {
    this.error = "";
    this.currentLanguage = Object.assign ({},  lang);

    this.modalService
      .open(content, { ariaLabelledBy: "modal-basic-title" })
      .result.then(result => { });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }

  getLanguages() {
    this.languageServiceApi
      .getLanguage()
      .pipe(first())
      .subscribe(res => {
        this.languages = res;
      });
  }

  deleteLanguage(lang) {
    Swal.fire({
      title: "Are you sure?",
      text: "Language data will be deleted. This action can't be reversed!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it"
    }).then(result => {
      if (result.value) {
        this.languageServiceApi
          .deleteLanguage(lang._id)
          .pipe(first())
          .subscribe(res => {
            this.getLanguages();
          });
      }
    });
  }

  onSave() {
    if (!this.currentLanguage.code) {
      this.alertService.err(this.sender, "Language Code cannot be Blank");
      return;
    }
    if (!this.currentLanguage.name) {
      this.alertService.err(this.sender, "Language Name cannot be Blank");
      return;
    }
    //saving ....validate ..
    this.languageServiceApi
      .saveLanguage(
        this.currentLanguage.code,
        this.currentLanguage.name,
        this.currentLanguage._id
      )
      .pipe(first())
      .subscribe(res => {
        this.languageres = res;
        if (this.languageres.error) {
          this.error = this.languageres.message.english;
          return;
        }
        this.alertService.show(this.sender, " Language added successfully");
        this.getLanguages();
        this.modalService.dismissAll();

      });
  }

  isChar(evt) {
    evt = evt ? evt : window.event;
    var charCode = evt.which ? evt.which : evt.keyCode;

    if (
      charCode > 31 &&
      ((charCode < 65 || charCode > 90) && (charCode < 97 || charCode > 122))
    ) {
      return false;
    }
    return true;
  }
}
